import React from 'react';

function FeedbackVirtualCardIcon() {
  return (
    <svg width={24} height={18} fill="none">
      <title>Ilustração de cartão virtual</title>
      <path
        d="M21.12 17.16v-.96h.48c.97 0 1.328-.206 1.416-.96h.962c-.133 1.338-.868 1.92-2.378 1.92h-.48zm-.96 0h-1.92v-.96h1.92v.96zM24 14.28h-.96v-1.92H24v1.92zm0-2.88h-.96V9.48H24v1.92zm0-2.88h-.96V6.6H24v1.92zm0-4.8v1.92h-.96V3.72H24zm-.022-.96h-.962c-.088-.754-.447-.96-1.416-.96h-.48V.84h.48c1.51 0 2.245.582 2.378 1.92zM20.16.84v.96h-1.92V.84h1.92zm-2.88 16.32h-1.92v-.96h1.92v.96zm0-16.32v.96h-1.92V.84h1.92zM14.4 17.16h-1.92v-.96h1.92v.96zm0-16.32v.96h-1.92V.84h1.92zm-2.88 16.32H2.4c-1.68 0-2.4-.72-2.4-2.4V3.24C0 1.56.72.84 2.4.84h9.12v.96H2.4C1.25 1.8.96 2.09.96 3.24v11.52c0 1.15.29 1.44 1.44 1.44h9.12v.96zM3.84 5.64h1.92c.53 0 .96.43.96.96v.96c0 .53-.43.96-.96.96H3.84a.96.96 0 01-.96-.96V6.6c0-.53.43-.96.96-.96z"
        fill="#111"
      />
    </svg>
  );
}

export default FeedbackVirtualCardIcon;
